// only catalogue quantities are shown here, ignore
export const noOpPackQuantityProvider = (itemNo: string) => null